import axios from "axios";
import { API_BASE_URL } from "./BaseURL";


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const LoginService = async (email, password) => {
  try {
    const response = await api.post("/login", { email, password });
    
    if (response.data.token) {
      localStorage.setItem("authToken", response.data.token);
      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }
    }

    return { success: true, data: response.data };
  } catch (error) {
    let errorMessage = "Login failed. Please try again.";
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMessage = "Invalid email or password";
          break;
        case 400:
          errorMessage = "Bad request. Please check your input";
          break;
        case 422:
          errorMessage = "Validation failed";
          break;
        default:
          errorMessage = error.response.data?.message || errorMessage;
      }
    } else if (error.request) {
      errorMessage = "No response from server. Check your connection.";
    }

    return { success: false, error: errorMessage };
  }
};

export const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
};

export const getToken = () => {
  return localStorage.getItem("authToken");
};

export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};